import { ROUTE_NAMES_LEGACY_ALL_REPORTS } from '@atlassian/jira-common-constants/src/spa-routes';

export const legacyAllReportsRoute = {
	name: ROUTE_NAMES_LEGACY_ALL_REPORTS,
	path: '/projects/:projectKey',
	query: ['selectedItem=(.*report-page.*)'],
};
